import React, { useState } from "react";
import Logo from "../assets/logo.png";
import { Link } from "react-router-dom";

function NewNavbar() {
  const [mobileMenu, setMobileMenu] = useState(false);

  return (
    <>
      {/* ==== NAVBAR ==== */}
      <div className="hidden md:block w-full absolute top-10 lg:left-0 bg-transparent">
        <div className="max-w-[1250px] mx-auto px-4 h-[60px] flex items-center justify-between">
          {/* LOGO */}
          <div className="w-[140px] h-[38px] flex-shrink-0 cursor-pointer">
            <Link to="/">
              <img
                src={Logo}
                alt="HYNT Logo"
                className="w-full h-full object-contain"
              />
            </Link>
          </div>

          {/* LINKS */}
          <div className="flex items-center gap-4">
            <Link
              to="/careers"
              className="px-4 py-2 font-nunito font-semibold text-[16px]"
            >
              Careers
            </Link>

            <Link
              to="/contact"
              className="px-4 py-2 font-nunito font-semibold text-[16px]"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>

      {/* ==== Mobile NAVBAR ==== */}
      <div
        className={`
          md:hidden z-[100]
          w-full h-auto flex flex-col px-4
          transition-all duration-300
          ${
            mobileMenu
              ? "bg-[#121815] text-white py-10"
              : "bg-white text-black py-10"
          }
        `}
      >
        {/* NAV TOP ROW */}
        <div className="w-full flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={Logo}
              alt="HYNT Logo"
              className="h-[35px] w-auto object-contain"
            />
          </Link>

          {/* Hamburger / Close */}
          <button
            onClick={() => setMobileMenu(!mobileMenu)}
            className="h-6 w-6 flex items-center justify-center"
          >
            {!mobileMenu ? (
              <img src="/navIcon.svg" alt="menu" className="h-6 w-6" />
            ) : (
              <img
                src="/closeIcon.svg"
                alt="close"
                className="h-[18px] w-[18px]"
              />
            )}
          </button>
        </div>

        {/* COLLAPSIBLE MENU */}
        <div
          className={`
      overflow-hidden transition-all duration-300
      ${mobileMenu ? "max-h-[300px] mt-6" : "max-h-0 mt-0"}
    `}
        >
          <div className="flex flex-col gap-4 border-b-2 pb-4">
            <Link
              to="/careers"
              className="font-nunito font-bold text-[24px] leading-[100%] text-right"
            >
              Careers
            </Link>

            <Link
              to="/contact"
              className="font-nunito font-bold text-[24px] leading-[100%] text-right"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewNavbar;
